import * as React from "react";
import * as S from "@styled";

export class FileReaderInput extends React.Component<IFileReaderProps, IFileReaderState> {
    private inputReference: React.RefObject<HTMLInputElement>;
    constructor(props: IFileReaderProps) {
        super(props);
        this.inputReference = React.createRef();
        this.onSelectFileClick = this.onSelectFileClick.bind(this);
        this.state = { generatedKey: this.generateNewKey() } as IFileReaderState;
    }

    /*
    * By generating a new key after succesfull file read, the input component will re-render and the same file can be uploaded again.
    */
    private generateNewKey(): number {
        return new Date().getTime();
    }

    onChange(): void {
        const files: FileList | undefined | null = this?.inputReference.current?.files;
        if (files && files.length === 1) {
            const file: File = files[0];
            const reader: FileReader = new FileReader();
            reader.onloadend = (event) => this.onFileLoadEnd(event, file.name);
            reader.readAsText(file);
        }
    }

    onFileLoadEnd(event: any, fileName: string): void {
        if (event.target.readyState === 2) { // ready state 2 = success
            const target: any = event.target as any;
            const fileContents: string = target.result as string;
            this.props.onFileRead(fileName, fileContents);
            this.setState({ generatedKey: this.generateNewKey() });
        }
    }

    onSelectFileClick() {
        this.inputReference.current?.click();
    }

    render(): JSX.Element {
        return (
            <S.FormGroup>
                <S.Label key={"fileReader-" + this.state.generatedKey}>
                    <S.Button onClick={this.onSelectFileClick}>{this.props.label}</S.Button>
                    <S.Input
                        type="file"
                        style={{ display: "none" }}
                        accept={this.props.accept}
                        ref={this.inputReference}
                        onChange={this.onChange.bind(this)} />
                </S.Label>
            </S.FormGroup>
        );
    }
}
export interface IFileReaderState {
    generatedKey: number;
}
export interface IFileReaderProps {
    label: string;
    accept: string;
    className?: string;
    onFileRead: (fileName: string, fileContents: string) => void;
}